<template>
  <el-button-group class="month-select-container" size="mini">
    <el-button size="small" type="primary" icon="el-icon-arrow-left" @click="prevMonth">上一月</el-button>
    <el-button size="small" type="primary" class="date-out">
      <el-date-picker v-model="ym"
                      value-format="yyyy-MM"
                      format="yyyy年MM月"
                      type="month"
                      placeholder="选择月份"
                      :clearable="false"
                      @change="setMonth" size="mini" class="date-picker"/>
      <i class="el-icon-arrow-down"/>
    </el-button>
    <el-button size="small" type="primary" @click="nextMonth">
      下一月
      <i class="el-icon-arrow-right el-icon--right"></i>
    </el-button>
  </el-button-group>
</template>

<script>
export default {
  name: "MonthSelectGroup",
  data() {
    return {
      searchCondition: {year: null, month: null},
      ym: null,
      visible: false
    }
  },
  watch: {
    searchCondition: {
      handler: function (_) {
        this.ym = _.year + '-' + _.month
      },
      deep: true
    }
  },
  methods: {
    setMonth(val) {
      if (val) {
        let arr = val.indexOf('-') > -1 ? val.split('-') : []

        if (arr.length === 2) {
          this.searchCondition.year = arr[0]
          this.searchCondition.month = arr[1]
          this.visible = false
          this.$emit('selected', this.searchCondition)
        }
      }
    },
    changeMonth(type) {
      let year = this.searchCondition.year
      let month = this.searchCondition.month

      const start = new Date(year, month - 1, 1);
      if (type === 'prev') {
        start.setMonth(start.getMonth() - 1);
      } else {
        start.setMonth(start.getMonth() + 1);
      }
      this.searchCondition.year = start.getFullYear()
      this.searchCondition.month = start.getMonth() + 1
      this.$emit('selected', this.searchCondition)
    },
    prevMonth() {
      this.changeMonth('prev')
    },
    nextMonth() {
      this.changeMonth('next')
    },
    getLastDays(days) {
      //几天前的时间
      let day1 = new Date();
      day1.setTime(day1.getTime() - 24 * 60 * 60 * 1000 * days);
      return day1.getFullYear() + "-" + (day1.getMonth() + 1) + "-" + day1.getDate();
    },
    defaultMonth() {
      let date = new Date();
      this.searchCondition.year = date.getFullYear()
      this.searchCondition.month = date.getMonth() + 1
      this.$emit('selected', this.searchCondition)
    }
  },
  mounted() {
    //默认年月
    this.defaultMonth()
  }
}
</script>

<style lang="scss">
.month-select-container {

  .el-button--small {
    padding: 5px 15px;
  }

  .date-out {
    padding: 0 15px;

    .date-picker {
      width: 65px;

      .el-input__inner {
        background: transparent;
        color: #FFFFFF;
        border: unset;
        height: 22px;
        line-height: 22px;
        padding-left: 0;
        padding-right: 0;
        cursor: pointer;
        caret-color: transparent;
      }

      .el-input__prefix {
        display: none;
      }
    }
  }
}
</style>
